import { cn } from '@/utilities/ui'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const variants = cva(
  ['font-caption', 'font-weight-caption', 'leading-caption', 'tracking-caption', 'text-caption'],
  {
    variants: {
      color: {
        default: [],
        subtle: ['text-olive-2/50'],
      },
    },
    defaultVariants: {
      color: 'default',
    },
  },
)

const Caption: React.FC<
  {
    ref?: React.Ref<HTMLSpanElement>
    asChild?: boolean
  } & React.HTMLAttributes<HTMLSpanElement> &
    VariantProps<typeof variants>
> = ({ className, ref, asChild, color, ...props }) => {
  const Comp = asChild ? Slot : 'span'
  return <Comp className={cn(variants({ color }), className)} ref={ref} {...props} />
}

export { Caption }
